import React from 'react'

const component = 'suggest'

export function SearchPhraseSuggestion({ searchSuggestion, basePath }) {
    return (
        <a className={`${component}__search-suggestion`} href={basePath + encodeURIComponent(searchSuggestion.trim())}>
            {searchSuggestion.trim()}
        </a>
    )
}
